import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "./ThemeContext";
import "./theme.css";

const GlobalThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      className="global-theme-toggle"
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "فعال کردن حالت روشن" : "فعال کردن حالت تاریک"}
      title={isDark ? "حالت روشن" : "حالت تاریک"}
    >
      {isDark ? <Sun size={19} /> : <Moon size={19} />}
      <span>{isDark ? "روشن" : "تاریک"}</span>
    </button>
  );
};

export default GlobalThemeToggle;
